(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26920],{

/***/ 928677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop",
      function () {
        return __webpack_require__(238758);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(504133);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links , schemaPage  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const schemaPageJson = typeof schemaPage === "string" ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getJson */ .LK)(schemaPage) : schemaPage;
    const schemas = Array.isArray(schemaPageJson) ? schemaPageJson : schemaPageJson && [
        schemaPageJson
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            }),
            !!(schemas === null || schemas === void 0 ? void 0 : schemas.length) && schemas.map((schema, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                }, index))
        ]
    });
};


/***/ }),

/***/ 770353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useIdentifiedPage = (className)=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const node = document.createElement("div");
        node.className = className;
        node.style.display = "none";
        document.body.prepend(node);
        return ()=>node.remove();
    }, []);
};


/***/ }),

/***/ 238758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ default_desktop; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./components/HeadSection.tsx
var HeadSection = __webpack_require__(665207);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./hooks/common.ts
var common = __webpack_require__(770353);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./modules/home/desktop/Home.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const DefaultHome = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(18089), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(57663), __webpack_require__.e(30481), __webpack_require__.e(47991)]).then(__webpack_require__.bind(__webpack_require__, 847991)).then((mod)=>mod.DefaultHome), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(847991)
            ]
    }
});
const PbHome = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57645), __webpack_require__.e(84868), __webpack_require__.e(18089), __webpack_require__.e(73676), __webpack_require__.e(25653), __webpack_require__.e(5441), __webpack_require__.e(51460), __webpack_require__.e(40059), __webpack_require__.e(70507), __webpack_require__.e(15930), __webpack_require__.e(40212), __webpack_require__.e(34785), __webpack_require__.e(48764), __webpack_require__.e(80771), __webpack_require__.e(6015), __webpack_require__.e(38361), __webpack_require__.e(40149), __webpack_require__.e(1528), __webpack_require__.e(27512), __webpack_require__.e(90823), __webpack_require__.e(24930), __webpack_require__.e(71925), __webpack_require__.e(40364), __webpack_require__.e(86827), __webpack_require__.e(23474), __webpack_require__.e(52237), __webpack_require__.e(92185), __webpack_require__.e(31871), __webpack_require__.e(17122), __webpack_require__.e(65725), __webpack_require__.e(60051), __webpack_require__.e(23862), __webpack_require__.e(44829), __webpack_require__.e(40440), __webpack_require__.e(29830), __webpack_require__.e(66673), __webpack_require__.e(6748), __webpack_require__.e(4499), __webpack_require__.e(49986), __webpack_require__.e(9508), __webpack_require__.e(10102), __webpack_require__.e(2835), __webpack_require__.e(21111), __webpack_require__.e(42129), __webpack_require__.e(25919), __webpack_require__.e(58705), __webpack_require__.e(75827), __webpack_require__.e(87310), __webpack_require__.e(58263), __webpack_require__.e(60544), __webpack_require__.e(95154), __webpack_require__.e(20510), __webpack_require__.e(2530), __webpack_require__.e(30162), __webpack_require__.e(29745), __webpack_require__.e(97103), __webpack_require__.e(16611), __webpack_require__.e(80025), __webpack_require__.e(46096), __webpack_require__.e(82904), __webpack_require__.e(51533), __webpack_require__.e(85675), __webpack_require__.e(73464), __webpack_require__.e(23686), __webpack_require__.e(82175), __webpack_require__.e(3243), __webpack_require__.e(12448), __webpack_require__.e(33687), __webpack_require__.e(58640), __webpack_require__.e(71798), __webpack_require__.e(96179), __webpack_require__.e(10837), __webpack_require__.e(28105), __webpack_require__.e(47891), __webpack_require__.e(75958), __webpack_require__.e(57502), __webpack_require__.e(70293), __webpack_require__.e(10959), __webpack_require__.e(54726), __webpack_require__.e(81379), __webpack_require__.e(31518), __webpack_require__.e(66387), __webpack_require__.e(56996), __webpack_require__.e(13289), __webpack_require__.e(84650), __webpack_require__.e(43437), __webpack_require__.e(21514), __webpack_require__.e(89041), __webpack_require__.e(89442), __webpack_require__.e(57325), __webpack_require__.e(64685), __webpack_require__.e(32666), __webpack_require__.e(78348), __webpack_require__.e(51513), __webpack_require__.e(27189), __webpack_require__.e(83692), __webpack_require__.e(14050), __webpack_require__.e(63443), __webpack_require__.e(68745), __webpack_require__.e(40274), __webpack_require__.e(72078), __webpack_require__.e(8746), __webpack_require__.e(76115), __webpack_require__.e(67128), __webpack_require__.e(1359), __webpack_require__.e(69343), __webpack_require__.e(35738), __webpack_require__.e(47402), __webpack_require__.e(17459), __webpack_require__.e(87015), __webpack_require__.e(74913), __webpack_require__.e(44876), __webpack_require__.e(59559), __webpack_require__.e(5603), __webpack_require__.e(71184), __webpack_require__.e(59033), __webpack_require__.e(20400), __webpack_require__.e(15577), __webpack_require__.e(39314), __webpack_require__.e(80832), __webpack_require__.e(73169), __webpack_require__.e(6826), __webpack_require__.e(38711), __webpack_require__.e(28178), __webpack_require__.e(42001), __webpack_require__.e(72964), __webpack_require__.e(39979), __webpack_require__.e(20892), __webpack_require__.e(89568), __webpack_require__.e(98555), __webpack_require__.e(30040), __webpack_require__.e(27223), __webpack_require__.e(30974), __webpack_require__.e(99466), __webpack_require__.e(61058), __webpack_require__.e(17786), __webpack_require__.e(47173), __webpack_require__.e(14945), __webpack_require__.e(37437), __webpack_require__.e(35437), __webpack_require__.e(73259), __webpack_require__.e(54668), __webpack_require__.e(77586), __webpack_require__.e(73579), __webpack_require__.e(10524), __webpack_require__.e(10790), __webpack_require__.e(79407), __webpack_require__.e(10943), __webpack_require__.e(36484), __webpack_require__.e(36539), __webpack_require__.e(56917), __webpack_require__.e(91693), __webpack_require__.e(21034), __webpack_require__.e(72975), __webpack_require__.e(40942), __webpack_require__.e(38535), __webpack_require__.e(92150), __webpack_require__.e(70342), __webpack_require__.e(23439), __webpack_require__.e(5916), __webpack_require__.e(63466), __webpack_require__.e(87924), __webpack_require__.e(14438), __webpack_require__.e(58431), __webpack_require__.e(56336), __webpack_require__.e(51123), __webpack_require__.e(75441), __webpack_require__.e(92589), __webpack_require__.e(39687), __webpack_require__.e(83147), __webpack_require__.e(29135), __webpack_require__.e(25773), __webpack_require__.e(30617), __webpack_require__.e(14554), __webpack_require__.e(98479), __webpack_require__.e(95043), __webpack_require__.e(36811), __webpack_require__.e(43216), __webpack_require__.e(21501), __webpack_require__.e(76630), __webpack_require__.e(76120), __webpack_require__.e(66499), __webpack_require__.e(52265), __webpack_require__.e(55375), __webpack_require__.e(9873), __webpack_require__.e(22209), __webpack_require__.e(90219), __webpack_require__.e(50307), __webpack_require__.e(40153), __webpack_require__.e(9395), __webpack_require__.e(81365), __webpack_require__.e(62455), __webpack_require__.e(7469), __webpack_require__.e(16357), __webpack_require__.e(30543), __webpack_require__.e(94905), __webpack_require__.e(57970), __webpack_require__.e(81147), __webpack_require__.e(50726), __webpack_require__.e(69603), __webpack_require__.e(41144), __webpack_require__.e(31282), __webpack_require__.e(48292), __webpack_require__.e(80300), __webpack_require__.e(55842), __webpack_require__.e(30176), __webpack_require__.e(14789), __webpack_require__.e(67140), __webpack_require__.e(46164), __webpack_require__.e(21583), __webpack_require__.e(46123)]).then(__webpack_require__.bind(__webpack_require__, 170919)).then((mod)=>mod.PbPage), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(170919)
            ]
    }
});
const Home = (_param)=>{
    var { menuItems , pbContent , pbMetaData , pbSSRData , menu  } = _param, defaultHomeProps = _objectWithoutProperties(_param, [
        "menuItems",
        "pbContent",
        "pbMetaData",
        "pbSSRData",
        "menu"
    ]);
    var ref;
    const { epicPb1887 , baseDomain , canonicalDomain  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    (0,common/* useIdentifiedPage */.w)("homePage");
    (0,react.useEffect)(()=>{
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadSection/* HeadSection */.I, _objectSpread({
                canonical: canonicalDomain || baseDomain
            }, epicPb1887 && pbMetaData ? {
                title: pbMetaData.metaTitle,
                description: pbMetaData.metaDescription,
                keywords: (ref = pbMetaData.metaKeywords) === null || ref === void 0 ? void 0 : ref.toString(),
                schemaPage: pbMetaData.jsonLd
            } : {})),
            epicPb1887 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PbHome, {
                pbContent: pbContent,
                pbSSRData: pbSSRData,
                pbMetaData: pbMetaData,
                menu: menu
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultHome, _objectSpread({
                menuItems: menuItems
            }, defaultHomeProps))
        ]
    });
};

;// CONCATENATED MODULE: ./tenants/_template/desktop/index.tsx
function desktop_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




const HomePage = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Home, desktop_objectSpread({}, props));
};
const getServerSideProps = (/* unused pure expression or super */ null && (getServerSidePropsHome));
/* harmony default export */ var desktop = (HomePage);

;// CONCATENATED MODULE: ./pages/default/desktop/index.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ var default_desktop = (desktop);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [97270,57645,98348,91961,300,92888,14560,40179], function() { return __webpack_exec__(928677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);